/*
 * @Description:
 * @Author: Mayer
 * @Date: 2020-06-29 16:38:29
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-11-13 21:35:58
 */
export default {
  lang: "阿拉伯语",
  landing: {
    name1: "افتح تطبيق كارلكير",
    name2: "إجراء حجز",
    name3: "افتح تطبيق كارلكير .. يمكنك ",
    name4: " التحقق معلومات الطلب في أي وقت!",
  },
  birLanding: {
    name1: "اختر طراز الجهاز",
    name2: "وصف الخلل:",
    name3: "رجاء حدد متجر البيع بالتجزئة",
    name4: "متجر الخدمة:",
    name5: "وقت الحجز:",
    name6: "يرجى وصف مشكلة جهازك بالتفصيل!",
    name7: "برجاء تحديد الوقت والتاريخ",
    name8: "يُرجى تعبئة ملعومات الشخصية بدقة حتى نتمكن من الاتصال بك!",
    name9: "وقت الحجز المتاح هو كما يلي!",
    name10: "برجاء إدخال رقم الهاتف",
    name11: "السعر",
    name12: "المعلومات الشخصية:",
    name13: "من فضلك أدخل إسمك",
    name14: "إرسال",
    name15: "إلغاء",
    name16: "موافق",
  },
  birRecord: {
    name1: "علامة تجارية",
    name2: "الطراز",
    name3: "عنصر",
    name4: "السعر",
    name5: "تنبيه:",
    name6:" هذه الأسعار مجرد مرجع فقط، يتم تحديد الأسعار الحقيقية حسب حالة الجهاز.",
    name7: " في حالة عدم وجود رمز خاص، يتم دفع سعر الجهاز بالعملة المحلية.",
    name8: "عفوًا! معلومات السعر غير متاحة في موقع البلد الحالي.",
  },
  birRules: {
    name1: "لا توجد أي بيانات حتى الآن",
    name2: "مزوِّد الخدمة:",
    name3: "العلامة التجارية للخدمة:",
    name4: "الهاتف :",
    name5: "كمية الطلب:",
    name6: "تقييم الخدمة",
    name7: "بيئة الخدمة:",
    name8: "توجه الخدمة:",
    name9: "كفاءة الخدمة:",
    name10: "جودة الخدمة:",
    name11: "تقييم العميل ",
    name12: "",
  },
};